module.exports = __webpack_public_path__ + "img/icon6.04702f28.png";